import { useEffect, useRef, useState } from "react";
import { formatMoney } from "@/lib/format";

export default function AnimatedNumber({ value, className = "", testId }) {
  const [display, setDisplay] = useState(value);
  const [pop, setPop] = useState(false);
  const previous = useRef(value);
  const rafRef = useRef(null);

  useEffect(() => {
    const from = previous.current;
    const to = value;
    if (from === to) return;

    const duration = 700;
    const start = performance.now();

    const step = (now) => {
      const t = Math.min(1, (now - start) / duration);
      // ease out cubic
      const eased = 1 - Math.pow(1 - t, 3);
      const current = from + (to - from) * eased;
      setDisplay(current);
      if (t < 1) {
        rafRef.current = requestAnimationFrame(step);
      } else {
        setDisplay(to);
        previous.current = to;
      }
    };

    rafRef.current = requestAnimationFrame(step);
    setPop(true);
    const popTimer = setTimeout(() => setPop(false), 600);

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      clearTimeout(popTimer);
    };
  }, [value]);

  return (
    <span
      data-testid={testId}
      className={`${className} ${pop ? "total-pop inline-block" : "inline-block"}`}
    >
      {formatMoney(display)}
    </span>
  );
}
